export const getLanguage = () => {
  return document.documentElement.lang || 'cs';
};



// WEBPACK FOOTER //
// ./node_modules/fg-frontend/components/FacebookBusiness/utils/getLanguage.js